module.exports = __webpack_public_path__ + "img/working-icon.abe3216e.svg";